import { useForm } from 'react-hook-form';
import { Card, CardBody, CardHeader, Col, Form, Row } from 'reactstrap';
import { H5, Btn } from '../../../AbstractElements';
import { CodTitle, Submit } from '../../../Constant';
import InputControl from '../../Common/FormInputs/InputControl';

const Cod = () => {
  const {register,formState: { errors }} = useForm();

  return (
    <>
      <Col xl='4' lg='6' className='box-col-33 debit-card '>
        <Card>
          <CardHeader className='pb-0'>
            <H5>{CodTitle}</H5>
          </CardHeader>
          <CardBody>
            <Form className='theme-form' >
              <Row>
                <Col sm='6' className='p-r-0'>
                  <InputControl label={false} controlInput='input' className='form-control' type='text' errors={errors} register={{ ...register('first_name', { required: 'is Required.' }) }} />
                </Col>
                <Col sm='6'>
                  <InputControl label={false} controlInput='input' className='form-control' type='text' errors={errors} register={{ ...register('last_name', { required: 'is Required.' }) }} />
                </Col>
                <Col sm='6' className='p-r-0'>
                  <InputControl label={false} controlInput='input' className='form-control' type='number' errors={errors} register={{ ...register('pin_code', { required: 'is Required.', maxLength: 6, minLength: 6 }) }} />
                </Col>
                <Col sm='6'>
                  <InputControl label={false} controlInput='input' className='form-control' type='number' errors={errors} register={{ ...register('phone_number', { required: 'is Required.', maxLength: 12, minLength: 12 }) }} />
                </Col>
                <Col sm='6' className='p-r-0'>
                  <InputControl label={false} controlInput='input' className='form-control' type='text' errors={errors} register={{ ...register('state', { required: 'is Required.' }) }} />
                </Col>
                <Col sm='6'>
                  <InputControl label={false} controlInput='input' className='form-control' type='text' errors={errors} register={{ ...register('city', { required: 'is Required.' }) }} />
                </Col>
                <Col sm='12'>
                  <InputControl label={false} row='4' controlInput='textarea' className='form-control' errors={errors} register={{ ...register('address', { required: 'is Required.' }) }} />
                </Col>
                <Col sm='12'>
                  <Btn color='primary' className='btn-block' type='submit'>
                    {Submit}
                  </Btn>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default Cod;
